/// <reference path="../src/desktop/core/services/authRedirection.service.ts"/>

import * as authRedirection from './services/desktop/authRedirection';
import mapLabel from './services/mapLabel';

import * as hotelStaticMapService from './services/hotelStaticMap';
import * as accountMenuService from './services/desktop/accountMenu';
import * as localStorageProvider from './services/desktop/localStorageProvider';

angular
    .module('core')
    .service('authRedirection', (): Core.AuthRedirection => authRedirection)
    .factory('mapLabel', () => mapLabel);

angular
    .module('TR')
    .constant('popupAuth', true)
    .service('hotelStaticMapService', () => hotelStaticMapService)
    .service('accountMenuService', () => accountMenuService)
    .service('localStorageProvider', () => localStorageProvider);
